export default __webpack_public_path__ + "static/media/project4.727ce43f.png";